export default __webpack_public_path__ + "static/media/power-65x.59ded621.webp";